module.exports = __webpack_public_path__ + "media/media/home/img1-05e84cd3bdb00b43a63e8501fda878fb.png";